import React from 'react';

const Scan = () => {
    return (
        <div>
            
        </div>
    );
};

export default Scan;